import { isDemoAffordanceHidden } from '../affordances'

import type { PropsWithChildren } from 'react'

/**
 * Renders its children everywhere except the demo build — the JSX gate for
 * mutating affordances (ticket 03; rationale on `isDemoAffordanceHidden`).
 * Mirrors `HasRole`/`HasActiveAnalyst` so the demo gates read like the role
 * gates they sit next to.
 */
export const DemoHidden = ({ children }: PropsWithChildren) => {
	if (isDemoAffordanceHidden) return null

	return <>{children}</>
}
